import React from 'react';
import Navigation from './Navigation';
import InfoTooltip from 'components/InfoTooltip';
import Q20 from 'ui/questions/Q20';
import PropTypes from 'prop-types';
import clsx from 'clsx';

function QuestionLabel({
  item,
  index,
  selectedValue,
  setSelectedValue,
  name,
  handleState,
  handleData,
}) {
  return (
    <label
      key={item.long || item.short}
      className="cursor-pointer"
      tabIndex={index}
    >
      <div
        className={clsx(
          'flex items-center outline-1 outline-bleu-hellio-500 w-full md:justify-center md:items-center md:flex-col p-2 md:space-y-2 md:w-52 md:text-center md:h-32 rounded-lg bg-white border-[2px] border-solid',
          {
            'border-amber-500': selectedValue === item.short,
          },
          {
            'border-transparent': selectedValue !== item.short,
          },
        )}
      >
        <img
          src={item.icon}
          alt={item.short}
          className="h-8 w-8 md:h-16 md:w-16 mdmb-1"
        />

        <div className="d-flex !text-sm px-2 md:px-0 ml-auto mr-auto">
          <span
            className={clsx({
              'text-amber-500': selectedValue === item.short,
            })}
          >
            {item.long}
          </span>
          {item.tooltip && (
            <InfoTooltip className="tooltip-bailleur">
              <h3>Propriétaire bailleur : </h3>
              <p className="mt-10">
                <strong>Un bailleur</strong> désigne une personne physique ou
                morale (banque, mutuelle, compagnie d&apos;assurance),
                généralement <strong>propriétaire</strong> d&apos;un bien
                immobilier et qui met celui-ci en location.
              </p>
            </InfoTooltip>
          )}
        </div>
      </div>
      <div className="flex">
        <input
          type="radio"
          name={name}
          value={item.short}
          onClick={(e) => {
            setSelectedValue(e.currentTarget.value);

            if (name === 'Q1') {
              handleState({ currentOffer: item });
            }
            handleData(e);
          }}
          className="hidden"
        />

        <div
          className={clsx({
            lh16: item.long.length > 18,
            lh22: item.long.length <= 18,
          })}
        ></div>
      </div>
    </label>
  );
}

QuestionLabel.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  selectedValue: PropTypes.string,
  setSelectedValue: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  handleState: PropTypes.func.isRequired,
  handleData: PropTypes.func.isRequired,
};

function Questions(props) {
  const previousResponse = props.state.answers[props.name] ?? null;
  const [selectedValue, setSelectedValue] = React.useState(previousResponse);
  const questions = props.dataItems;
  const currentQuestion = questions[props.name];
  const currentQuestionItems = props.dataItems[props.name];
  const isQ20 = props.name === 'Q20';

  React.useEffect(() => {
    setSelectedValue(previousResponse);
  }, [currentQuestionItems, previousResponse]);

  const items = currentQuestionItems.items;

  if (isQ20) {
    return (
      <div className="fadeIn flex flex-col md:mb-32">
        <Q20
          node={currentQuestion}
          options={{ hideTitle: true }}
          questions={questions}
          value={props.data}
          whenAnswered={props.handleSituationOccupant}
          state={props.state}
          handleState={props.handleState}
        />

        <Navigation
          data={props.data}
          step={props.step}
          nextStep={props.nextStep}
          lastStep={props.lastStep}
          loadingParcours={props.loadingParcours}
          leadsource={props.leadsource}
          lastStepPrequestion={props.lastStepPrequestion}
        />
      </div>
    );
  }

  return (
    <div className="fadeIn flex flex-col items-center">
      <div
        className={clsx(
          'w-full flex flex-col justify-center flex-wrap gap-2',
          {
            'label-grid-container md:grid md:gap-4 lg:grid-cols-4':
              items.length > 3,
          },
          {
            'md:flex-row md:gap-4': items.length <= 3,
          },
        )}
      >
        {items.map((item, index) => {
          return (
            <QuestionLabel
              key={item.long || item.short}
              item={item}
              index={index}
              selectedValue={selectedValue}
              setSelectedValue={setSelectedValue}
              name={props.name}
              handleState={props.handleState}
              handleData={props.handleData}
            />
          );
        })}
      </div>

      <Navigation
        data={selectedValue}
        step={props.step}
        nextStep={props.nextStep}
        lastStep={props.lastStep}
        loadingParcours={props.loadingParcours}
        leadsource={props.leadsource}
        lastStepPrequestion={props.lastStepPrequestion}
      />
    </div>
  );
}

Questions.propTypes = {
  dataItems: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  data: PropTypes.string,
  handleState: PropTypes.func.isRequired,
  handleData: PropTypes.func.isRequired,
  handleSituationOccupant: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired,
  step: PropTypes.number.isRequired,
  nextStep: PropTypes.func.isRequired,
  lastStep: PropTypes.func.isRequired,
  loadingParcours: PropTypes.bool,
  leadsource: PropTypes.string,
  lastStepPrequestion: PropTypes.func.isRequired,
};

export default Questions;
